export default "__VITE_ASSET__DRgaAOAE__"